/*
 * @Description: 
 * @Author: shenkaiyao
 * @Date: 2020-08-06 17:02:44
 * @LastEditors: 
 * @LastEditTime: 2020-08-21 10:14:44
 */
import VerificationSlide from './verification';

export default VerificationSlide